import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from '../base/base.service';

declare var $: any;

@Injectable({
  providedIn: 'root',
})

export class AccountService extends BaseService {
  public auth: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public profile: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  //say if we alreday printed a welcom message to a user
  public welcomedUser = false;

  constructor() {
    super('compte');

    this.checkSession();
  }

  get isAuth(): boolean {
    return this.auth.value;
  }

  set isAuth(state: boolean) {
    this.auth.next(state);
  }

  start_registration(formValue: any): Observable<any> {
    return this.post('start-registration', formValue);
  }

  cancel_registration(token: string): Observable<any> {
    return this.delete('registration/' + token);
  }

  check_token(token: string): Observable<any> {
    return this.get('registration/check-token/' + token);
  }

  register(formValue: any): Observable<any> {
    return this.post('end-registration', formValue);
  }

  login(formValue: any): Observable<any> {
    return this.post('login', formValue);
  }

  login_using_facebook(formValue: any): Observable<any> {
    return this.post('login/facebook', formValue);
  }

  send_reset_password_link(formValue: any): Observable<any> {
    return this.post('send-reset-link', formValue);
  }

  reset_password(formValue: any): Observable<any> {
    return this.put('reset-password', formValue);
  }

  update_profile(formValue: any): Observable<any> {
    return this.put('update-profile', formValue);
  }

  update_mail(formValue: any): Observable<any> {
    return this.put('update-mail', formValue);
  }

  update_password(formValue: any): Observable<any> {
    return this.put('update-password', formValue);
  }

  authenticate(accountInfo: any, rememberMe: boolean) {
    if (rememberMe) {
      localStorage.setItem('account', JSON.stringify(accountInfo.user));
      localStorage.setItem('token', JSON.stringify(accountInfo.token));
      this.getApiToken();
      this.checkSession(false);
    } else {
      this.profile.next(accountInfo.user);
      this.auth.next(true);
    }
  }

  checkSession(verifyTokenValidity: boolean = true): boolean {
    let token: any = JSON.parse(localStorage.getItem('token'));
    if (!this.auth.value && token) {
      if (!verifyTokenValidity) {
        this.profile.next(JSON.parse(localStorage.getItem('account')));
        this.auth.next(true);
      } else {
        //check token validity and ask user data to the server
        this.get('authentify').subscribe(
          (res: any) => {
            if (res.success) {
              localStorage.setItem('account', JSON.stringify(res.data.user));
              this.profile.next(res.data.user);
              this.auth.next(true);
            } else {
              localStorage.removeItem('account');
              localStorage.removeItem('token');
              this.auth.next(false);
              this.notify('warning', 'accountSuspendu', true, 10000);
              this.goTo('/account/login');
            }
          },
          (error: any) => {
            localStorage.removeItem('account');
            localStorage.removeItem('token');
            this.auth.next(false);
            this.notify('warning', 'sessionExpired', true, 10000);
            this.goTo('/account/login');
          }
        );
      }

      this.profile.next(JSON.parse(localStorage.getItem('account')));
      this.auth.next(true);
      return true;
    }
    return false;
  }

  refrehSession() {
    this.get('authentify').subscribe(
      (res: any) => {
        if (res.success) {
          localStorage.setItem('account', JSON.stringify(res.data.user));
          this.profile.next(res.data.user);
          this.auth.next(true);
        }

      },
      (error: any) => {
      }
    );
  }

  access(module: string): boolean {
    let canContinue = false;
    // ADMIN
    if (this.profile?.value?.user_type?.id == 1) {
      switch (module) {
        case 'home':
          canContinue = true;
          break;
        case 'stock':
          canContinue = true;
          break;
        case 'sales':
          canContinue = true;
          break;
        case 'finance':
          canContinue = true;
          break;
        case 'utilisateur':
          canContinue = true;
          break;
        case 'config':
          canContinue = true;
          break;
        case 'dashboard':
          canContinue = true;
          break;
        case 'account':
          canContinue = true;
          break;

        case 'product-index':
          canContinue = true;
          break;
          case 'product-archive':
            canContinue = true;
            break;
        case 'product-details':
          canContinue = true;
          break;
        case 'customer-index':
          canContinue = true;
          break;
        case 'customer-debt':
          canContinue = true;
          break;
        case 'order-create':
          canContinue = true;
          break;
        case 'order-edit':
          canContinue = true;
          break;
        case 'order-index':
          canContinue = true;
          break;
        case 'order-details':
          canContinue = true;
          break;
        default:

          break;
      }
    }
    //VALIDAEUR
    else if (this.profile?.value?.user_type?.id == 2 || this.profile?.value?.user_type?.id == 3) {
      switch (module) {
        case 'home':
          canContinue = true;
          break;
        case 'product-index':
          canContinue = true;
          break;
          case 'product-archive':
            canContinue = true;
            break;
        case 'product-details':
          canContinue = true;
          break;
        case 'customer-index':
          canContinue = true;
          break;
        case 'order-create':
          canContinue = true;
          break;
        case 'order-edit':
          canContinue = true;
          break;
        case 'order-index':
          canContinue = true;
          break;
        case 'order-details':
          canContinue = true;
          break;
        case 'account':
          canContinue = true;
          break;

        default:

          break;
      }
    }

    return canContinue;
  }

  authoizedModules(user_type_id: number) {
    if (user_type_id == 5) {

    }
  }

  logout() {
    this.requestings.logout = true;
    this.notify('simple', 'loggetOutProcessing', true, 3000);
    this.get('logout').subscribe(
      (res: any) => {
        if (res.success) {

          localStorage.removeItem('account');
          localStorage.removeItem('token');
          this.auth.next(false);
          this.requestings.logout = false;
          this.goTo('/account/login');
        }
      },
      (error) => {
        this.notify('warning', 'serverError', true, 5000);
      }
    );
  }

  setBackgroundImage() {
    $('body').addClass('bodyBkgImg');
  }
}
